import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@uk-source-web/collapsible-container';
import { useEffect } from 'react';
import { BasketMoreInformationWrapper } from '../../SWBasket.styles';
import BasketMoreInformationContent from '../../BasketDiscount/BasketMoreInformationContent/BasketMoreInformationContent';
import handleTranslation from '@/helpers/handleTranslation';
import { useBasketSummary } from '@/contexts/BasketSummaryContext/BasketSummary';
import { useAppSelector } from '@/store';

const BasketMoreInformation = () => {
  const moreInformationText = handleTranslation('More information', 'Detalhes');
  const { basketSummary, fetchBasketSummary, isLoading, error } = useBasketSummary();
  const { user } = useAppSelector(({ userSession }) => userSession);
  const { userBasket } = useAppSelector(({ userBasket: { data } }) => ({
    userBasket: data,
  }));



  const renderBasketContent = () => {
    if (basketSummary) {
      return <BasketMoreInformationContent basketSummary={basketSummary.data} />;
    }

    if (isLoading) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>{error}</p>;
    }

    return <p>No additional information available.</p>;
  };

  useEffect(() => {
    if (userBasket.items.length > 0) {
      fetchBasketSummary(userBasket, user);
    }
  }, [userBasket, user]);
  return (
    <BasketMoreInformationWrapper>
      <CollapsibleContainer appearance="primary">
        <CollapsibleContainerHeader>{moreInformationText}</CollapsibleContainerHeader>
        <CollapsibleContainerBody>{renderBasketContent()}</CollapsibleContainerBody>
      </CollapsibleContainer>
    </BasketMoreInformationWrapper>
  );
};

export default BasketMoreInformation;
